import { BreakdownTab, useDashboardContext, useDashboardDispatch } from "@/contexts/DashboardContext"

import SalesBreakdownChart from "../SalesBreakdownChart/SalesBreakdownChart";
import ProductsSoldTable from "../ProductsSoldTable/ProductsSoldTable";
import { getOrderItemSalesBreakdown, getProductSalesBreakdown, getSellerSalesBreakdown } from "@/api/seller-analytics";
import styles from "./sales-breakdown.module.css";
import OrderItemsSoldTable from "../OrderItemsTable/OrderItemsTable";
import PillTabs from "@/components/PillTabs/PillTabs";

export const SalesBreakdown = () => {
  const { activeBreakdownTab, activeSnapshotIndex, salesSnapshotCards } = useDashboardContext();

  const dispatch = useDashboardDispatch();

  const tabs = ["sales", "products", "order-items"]
  const handleBreakdownTabChange = async (value: string) => {
    const selectedTab = value as BreakdownTab
    const selectedInterval = salesSnapshotCards[activeSnapshotIndex].defaultInterval;
    if (selectedTab === activeBreakdownTab) return;

    dispatch({ type: 'BREAKDOWN_TAB_CHANGED', data: { tab: selectedTab } });

    if (selectedTab === 'products') {
      const productSalesResponse = await getProductSalesBreakdown(selectedInterval)
      dispatch({ type: 'PRODUCT_SALES_BREAKDOWN_DATA_LOADED', data: { tableData: productSalesResponse } })
    } else if (selectedTab === 'order-items') {
      const orderItemsalesResponse = await getOrderItemSalesBreakdown(
        selectedInterval)
      dispatch({ type: 'ORDER_ITEM_SALES_BREAKDOWN_DATA_LOADED', data: { tableData: orderItemsalesResponse } })
    } else {
      const salesBreakdown = await getSellerSalesBreakdown(salesSnapshotCards[activeSnapshotIndex].defaultInterval)
      dispatch({ type: 'SALES_BREAKDOWN_DATA_LOADED', data: { breakdownData: salesBreakdown } })
    }
  };

  return (
    <PillTabs
      tabs={tabs}
      className={styles.breakdownContainer}
      triggerRender={tabId => {
        switch (tabId) {
          case "sales": return "Sales Over Time";
          case "products": return "Products Sold";
          case "order-items": return "Order Items";
        }
      }}
      contentRender={tabId => {
        switch (tabId) {
          case "sales": return <SalesBreakdownChart />;
          case "products": return <ProductsSoldTable />;
          case "order-items": return <OrderItemsSoldTable />;
        }
      }}
      onTabChange={handleBreakdownTabChange}
    />
  )
}